const manutencao_do_retorno_de_vaga_por_municipio = {
  path: "/manutencao-do-retorno-de-vaga-por-municipio",
  redirect: "/manutencao-do-retorno-de-vaga-por-municipio",
  meta: {
    breadCrumb: "Gerenciamento de Matrícula - Parâmetros por Município",
  },
  children: [
    {
      path: "/manutencao-do-retorno-de-vaga-por-municipio/novo",
      name: "manutencao_do_retorno_de_vaga_por_municipio_novo",
      meta: {
        allowedPermissions: ["retorno_vaga_create"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDoRetornoDeVagaPorMunicipio/ManutencaoDoRetornoDeVagaPorMunicipioCad.vue"
        ),
    },
    {
      path: "/manutencao-do-retorno-de-vaga-por-municipio/edit/:id",
      name: "manutencao_do_retorno_de_vaga_por_municipio_atualizar",
      meta: {
        allowedPermissions: ["retorno_vaga_edit"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDoRetornoDeVagaPorMunicipio/ManutencaoDoRetornoDeVagaPorMunicipioEdit.vue"
        ),
    },
    {
      path: "/manutencao-do-retorno-de-vaga-por-municipio",
      name: "manutencao-do-retorno-de-vaga-por-municipio",
      meta: {
        allowedPermissions: ["retorno_vaga_list"],
      },
      component: () =>
        import(
          "@/views/ManutencaoDoRetornoDeVagaPorMunicipio/ManutencaoDoRetornoDeVagaPorMunicipioHome.vue"
        ),
    },
  ],
};

export { manutencao_do_retorno_de_vaga_por_municipio };
